import { groupBy } from 'lodash';

export const getLocationsMachinesName = (deviceIds, switches) => {
  const locationsMachines = [];
  console.log('deviceIds', { deviceIds, switches });
  deviceIds.map((deviceId) => {
    Object.values(switches).map((zone, zoneIndex) => {
      Object.values(zone).map((machine, machineIndex) => {
        if (machine.deviceMac === deviceId) {
          const locationName = Object.keys(switches)[zoneIndex];
          const machineName = Object.keys(zone)[machineIndex];
          locationsMachines.push([locationName, machineName]);
        }
      });
    });
  });

  const locationsMachinesGrouped = groupBy(locationsMachines, (el) => el[0]);
  const locations = Object.keys(locationsMachinesGrouped);
  const machines = Object.values(locationsMachinesGrouped).map((el) =>
    el.map((el) => el[1])
  );

  return { locations, machines };
};

export const getLocationDataByDeviceId = (deviceId, swtStatus) => {
  for (const location in swtStatus) {
    if (
      swtStatus[location].devices?.hasOwnProperty(deviceId) ||
      swtStatus[location].hasOwnProperty(deviceId)
    ) {
      return swtStatus[location] || {};
    }
  }
  return {};
};

export const getSelectedDeviceIds = (
  masterControlSelects,
  swtSwitch,
  swtName
) => {
  return masterControlSelects[swtName].isMachineSelected
    .map((arr, idxArr) => {
      return arr.map((el, edxEl) => {
        if (Array.isArray(el)) {
          if (el.some(Boolean)) {
            return Object.keys(
              Object.values(Object.values(swtSwitch)[idxArr].subLocations)[
                edxEl
              ].devices
            );
          }
        } else if (el) {
          const location = Object.values(swtSwitch)[idxArr]?.devices;
          console.log(location, 'getSelectedDeviceIds');
          return Object.keys(location)[edxEl];
        }
        return false;
      });
    })
    .flat()
    .filter((el) => el);
};

export const getDeviceIdsByLocationData = (locations) => {
  const deviceIds = [];
  Object.values(locations).forEach((location) => {
    deviceIds.push(...Object.keys(location));
  });
  const result = [...new Set(deviceIds)];
  return result;
};

export const getMachineDataByInhandId = (inhandId, swtSwitch) => {
  for (const location in swtSwitch) {
    for (const machine in swtSwitch[location]) {
      if (swtSwitch[location][machine].inhandId === inhandId) {
        return swtSwitch[location][machine];
      }
    }
  }
};

export const getAllSpecificLocationNames = (data) => {
  const allSpecificLocationsName = [];
  data &&
    Object.values(data).forEach((value) => {
      if (value.isSpecificLocation) {
        allSpecificLocationsName.push(Object.keys(value.subLocations));
      }
    });
  return allSpecificLocationsName;
};

export const getSpecLocationHandler = (data) => {
  return Object.values(data).filter((location) =>
    Object.values(location).some((el) => !el.deviceMac)
  );
};

export const transformSpecificLocationData = (data, scope) => {
  const filteredData = Object.entries(data).filter(
    ([key, value]) => key === scope
  )[0];
  return { [filteredData[0]]: filteredData[1] };
};

export const getSpecificLocationNameOfALocation = (location) => {
  const allSpecificLocationsName = [];
  location &&
    Object.entries(location).forEach(([key, value]) => {
      if (Object.values(value)[0]?.deviceMac && Object.keys(value).length > 0) {
        allSpecificLocationsName.push(key);
      }
    });
  return allSpecificLocationsName;
};

export const extractSwtSize = (name) => {
  if (name) {
    return name.match(/\d+/g);
  } else {
    return '';
  }
};

export const extractApplicationAbr = (name) => {
  if (name) {
    return name
      .replace(/[^a-zA-Z\s]/g, '')
      .replace(/\s+/g, ' ')
      .split(' ')
      .filter((word) => word && word.trim() !== '')
      .reduce((prev, word) => {
        if (prev) {
          return `${prev}.${word.charAt(0).toLowerCase()}`;
        }
        return word.charAt(0).toLowerCase();
      }, '');
  } else {
    return '';
  }
};

export const getFormattedMachineName = (swtData) => {
  const locations = Object.keys(swtData).map((location) =>
    Object.entries(swtData[location]).flatMap(([key, el]) => {
      if (el.deviceMac) {
        return `${location} - ${key}`;
      } else {
        return Object.keys(swtData[location][key]).flatMap(
          (machine) => `${location} - ${key} - ${machine}`
        );
      }
    })
  );

  return locations.reduce((acc, cur) => acc.concat(cur), []);
};

export const getLocationAssignedUsersByDeviceIds = (
  deviceIds,
  allLocations
) => {
  const assignedUsers = [];
  deviceIds.forEach((deviceId) => {
    assignedUsers
      .push
      ();
  });
  return [...new Set(assignedUsers.flat())];
};
